import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PerformanceGraphComponent } from './performance-graph.component';

const routes: Routes = [
  {
    path: '',
    component: PerformanceGraphComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PerformanceGraphRoutingModule {}
